// Common
import { callQBookingApi } from "./common";

// Utils
import { get, post, put } from "Utils/HTTPMethods";

export const getAllClients = () => callQBookingApi(get, "/client");

export const getClient = (id) => callQBookingApi(get, "/client", { id });

export const getClientByDomain = (domain) =>
  callQBookingApi(get, "/client", { domain });

export const createClient = (client) =>
  callQBookingApi(post, "/client", client);

export const updateClient = (clientData) =>
  callQBookingApi(put, "/client", clientData);
